import { useState } from "react";
import { Menu, Sidebar, MenuItem } from "react-pro-sidebar";
import { useProSidebar } from "react-pro-sidebar";
import logo from '../assets/img/codeflare-app.webp';
import js from '../assets/img/atom.png';
import user from '../assets/img/user.png';
import { useSidebarContext } from "./SidebarCourseContext";
import Greet  from '../components/GreetUser';
import { Link } from "react-router-dom";
import { tokens } from "../theme";
import { useTheme, Box, Typography, IconButton } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import LocalLibraryOutlinedIcon from "@mui/icons-material/LocalLibraryOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import LoyaltyOutlinedIcon from "@mui/icons-material/LoyaltyOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import SwitchRightOutlinedIcon from "@mui/icons-material/SwitchRightOutlined";
import SwitchLeftOutlinedIcon from "@mui/icons-material/SwitchLeftOutlined";
const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <MenuItem
      active={selected === title}
      style={{ color: colors.white[100] }}
      onClick={() => setSelected(title)}
      icon={icon}
      routerLink={<Link to={to} />}
    >

      <Typography>{title}</Typography>
    </MenuItem>
  );
};

const ReactCourseNav = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selected, setSelected] = useState("");
  const { sidebarRTL, setSidebarRTL, sidebarImage } = useSidebarContext();
  const { collapseSidebar, toggleSidebar, collapsed, broken } = useProSidebar();
  return (
    <Box
      sx={{
        position: "sticky",
        display: "flex",
        height: "100vh",
        top: 0,
        bottom: 0,
        zIndex: 10000,
        "& .sidebar": {
          border: "none",
        },
        "& .menu-icon": {
          backgroundColor: "transparent !important",
        },
        "& .menu-item": {
          padding: "5px 35px 5px 20px !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-anchor": {
          color: "inherit !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-item:hover": {
          color: `${colors.blueAccent[100]} !important`,
          backgroundColor: `${colors.blueAccent[100]} !important`,
        },
        "& .menu-item.active": {
          color: `${colors.blueAccent[100]} !important`,
          backgroundColor: `${colors.blueAccent[100]} !important`,
        },
      }}
    >
      <Sidebar
        breakPoint="md"
        rtl={sidebarRTL}
        backgroundColor={colors.primary[200]}
        image={sidebarImage}
      >
        <Menu iconshape="square"
        menuItemStyles={{
        button: ({ level, active, disabled }) => {
          // only apply styles on first level elements of the tree
          return {
           color: disabled ? '#f5d9ff' : '#FFF',
           backgroundColor: active ? '#eecef9' : undefined,
           '&:hover': {
              backgroundColor: 'hsl(217, 28%, 15%)',
            },
         };
        },
      }}

        >
          <MenuItem
            icon={
              collapsed ? (
                <MenuOutlinedIcon onClick={() => collapseSidebar()} />
              ) : sidebarRTL ? (
                <SwitchLeftOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              ) : (
                <SwitchRightOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              )
            }
            style={{
              margin: "10px 0 20px 0",
              color: colors.blueAccent[100],
            }}
          >
            {!collapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
              <img
                className="avater-image"
                alt="Codefussion"
                width="30%"
                height="auto"
                src={logo}
                style={{ cursor: "pointer", alignSelf: 'center' }}
              />
                <IconButton
                  onClick={
                    broken ? () => toggleSidebar() : () => collapseSidebar()
                  }
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>
          {!collapsed && (
            <Box mb="25px">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  "& .avater-image": {
                    backgroundColor: colors.primary[500],
                  },
                }}
              >
                <img
                  className="avater-image"
                  alt="profile user"
                  width="72px"
                  height="72px"
                  src={js}
                  style={{ cursor: "pointer" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color={colors.white[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                  style={{ textAlign: 'center' }}
                >
                  {/*<Greet /> */}
                  <h3 className="text-light">React</h3>
                </Typography>
              </Box>
            </Box>
          )}
          <Box paddingLeft={collapsed ? undefined : "1%"}>
          <MenuItem className={window.location.href.toString().includes("dashboard") ? 'active' : ''} icon={<HomeOutlinedIcon />} component={<Link to="/dashboard" />}>Go to Dashbord</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-course-outline") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-course-outline" />}>Course outline</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-history-and-purpose-of-reactjs") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-history-and-purpose-of-reactjs" />}>1. History and Purpose of ReactJS</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-setting-up-react-environment") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-setting-up-react-environment" />}>2. Setting Up React Environment</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-understandingjsx") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-understandingjsx" />}>3.Understanding JSX</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-component") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-component" />}>4. React Component</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-project-architecture") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-project-architecture" />}>5. React Project Architecture</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-state-management") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-state-management" />}>6. State Management</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-importing-files") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-importing-files" />}>7. Importing Files</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-router") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-router" />}>8. React Router</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-styling-component") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-styling-component" />}>9. Styling Component</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-bootstrap") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-bootstrap" />}>10. React Bootstrap</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-conditional-rendering") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-conditional-rendering" />}>11. Conditional Rendering</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-lifecycle-method") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-lifecycle-method" />}>12.Lifecycle Method</MenuItem>
          <MenuItem className={window.location.href.toString().includes("react-hooks") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/react-hooks" />}>13. React Hooks</MenuItem>

          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default ReactCourseNav;
